import * as React from 'react';
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport } from '@shared-ui/viewport-context';
import { getGCSectionData } from '../gc-section-data';
import { HeaderNavMenuLinks } from './header-nav-menu-links';
import { HeaderNavLobLinks } from './header-nav-lob-links';
import { AdditionalHeaderMenus } from './additional-header-menus';
var EXTRA_LARGE_BREAKPOINT_NUMBER_OF_LINKS = 5;
var LARGE_BREAKPOINT_NUMBER_OF_LINKS = 3;
var MEDIUM_BREAKPOINT_NUMBER_OF_LINKS = 0;
var HeaderNavToolbar = function (_a) {
  var analytics = _a.analytics,
    globalComponentsContext = _a.globalComponentsContext,
    page = _a.page,
    showHeaderNavMenuLinks = _a.showHeaderNavMenuLinks,
    minimal = _a.minimal,
    simplified = _a.simplified,
    shopTravelForced = _a.shopTravelForced;
  return React.createElement(Viewport, null, React.createElement(ViewMedium, null, React.createElement(HeaderToolbarNavItems, {
    numberOfLinks: MEDIUM_BREAKPOINT_NUMBER_OF_LINKS,
    analytics: analytics,
    globalComponentsContext: globalComponentsContext,
    page: page,
    showHeaderNavMenuLinks: showHeaderNavMenuLinks,
    minimal: minimal,
    simplified: simplified,
    shopTravelForced: shopTravelForced
  })), React.createElement(ViewLarge, null, React.createElement(HeaderToolbarNavItems, {
    numberOfLinks: LARGE_BREAKPOINT_NUMBER_OF_LINKS,
    analytics: analytics,
    globalComponentsContext: globalComponentsContext,
    page: page,
    showHeaderNavMenuLinks: showHeaderNavMenuLinks,
    minimal: minimal,
    simplified: simplified,
    shopTravelForced: shopTravelForced
  })), React.createElement(ViewExtraLarge, null, React.createElement(HeaderToolbarNavItems, {
    numberOfLinks: EXTRA_LARGE_BREAKPOINT_NUMBER_OF_LINKS,
    analytics: analytics,
    globalComponentsContext: globalComponentsContext,
    page: page,
    showHeaderNavMenuLinks: showHeaderNavMenuLinks,
    minimal: minimal,
    simplified: simplified,
    shopTravelForced: shopTravelForced
  })));
};
export var HeaderToolbarNavItems = function (_a) {
  var _b = _a.numberOfLinks,
    numberOfLinks = _b === void 0 ? 0 : _b,
    analytics = _a.analytics,
    globalComponentsContext = _a.globalComponentsContext,
    page = _a.page,
    showHeaderNavMenuLinks = _a.showHeaderNavMenuLinks,
    minimal = _a.minimal,
    simplified = _a.simplified,
    shopTravelForced = _a.shopTravelForced;
  var navLinksSection = getGCSectionData(globalComponentsContext, 'header', 'navLinks');
  if (!navLinksSection || !navLinksSection.sectionData || !navLinksSection.sectionData.length || minimal) {
    return null;
  }
  var navLinks = navLinksSection.sectionData.filter(function (item) {
    return item.type === 'link';
  });
  var displayedLinkCount = navLinks.length < 3 ? 0 : numberOfLinks;
  var shopTravel = React.createElement(HeaderNavMenuLinks, {
    analytics: analytics,
    globalComponentsContext: globalComponentsContext,
    numberOfLinks: 0
  });
  var lobLinks = React.createElement(React.Fragment, null, React.createElement(HeaderNavLobLinks, {
    analytics: analytics,
    numberOfLinks: displayedLinkCount,
    globalComponentsContext: globalComponentsContext
  }), showHeaderNavMenuLinks && React.createElement(HeaderNavMenuLinks, {
    analytics: analytics,
    globalComponentsContext: globalComponentsContext,
    numberOfLinks: shopTravelForced ? 0 : displayedLinkCount
  }));
  return React.createElement("nav", {
    id: "header-toolbar-nav",
    className: "global-nav-header-links__nav",
    "aria-label": "primary"
  }, simplified ? shopTravel : lobLinks, React.createElement(AdditionalHeaderMenus, {
    analytics: analytics,
    globalComponentsContext: globalComponentsContext
  }));
};
export { HeaderNavToolbar };